import request from '../request'

// MF-67 — Journal zones API (Maestro-managed school areas for location + heatmap).
export const getZones = (params = {}) => request.get('/journal/zones', { params }).then((res) => res)

export const getZone = (zoneId = '') => request.get(`/journal/zones/${zoneId}`).then((res) => res)

export const createZone = (data = {}) => request.post('/journal/zones', data).then((res) => res)

export const updateZone = (zoneId = '', data = {}) =>
  request.put(`/journal/zones/${zoneId}`, data).then((res) => res)

export const deleteZone = (zoneId = '') => request.delete(`/journal/zones/${zoneId}`).then((res) => res)
